import { TEMP_IMG } from "../config.js";
import i18next from "../i18n";
import {
  getEnabledMobileMoneyProviders,
  getMobileMoneyProvider,
} from "../mobileMoneyProviders.js";
import View from "./View";

class CartView extends View {
  _btnCheckout = document.querySelector(".checkout-button");
  _btnCloseCheckout = document.querySelector(".button-close.checkout");
  _btnEditDeliveryDetails = document.querySelector(".edit-delivery-details");
  _btnTipCustom = document.querySelector(".button-tip-js.custom");
  _btnTipGenerous = document.querySelector(".button-tip-js.generous");
  _btnTipModest = document.querySelector(".button-tip-js.modest");
  _btnTipStandard = document.querySelector(".button-tip-js.standard");
  // eslint-disable-next-line
  _callback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        this.handleTipChange();
      }
    }
  };
  _cartSuccess = document.querySelector(".cart-success");

  _cartSuccessContainer = document.querySelector(".success-message");

  // Options for the observer (which mutations to observe)
  _config = { childList: true, subtree: true };
  _contactInfo = document.querySelector(".contact-info");
  _data;
  _deliveryDay = document.querySelector("#service-date");
  _deliveryMinimumContainer = document.querySelector(
    ".delivery-minimum-container",
  );
  _deliveryTime = document.querySelector("#service-time");
  _fulfillmentHelper = document.querySelector(".checkout-fulfillment-helper");
  _fulfillmentHelperText = document.querySelector(
    ".checkout-fulfillment-helper-text",
  );
  _inputTipCustom = document.querySelector(".custom-tip-input");
  // Interval of delivery is taken from API
  _intervalDelivery = undefined;
  _labelAddress = document.querySelector(".label-address");
  _modalBackgroundCheckout = document.querySelector(
    ".modal-background.checkout",
  );
  // Create an observer instance linked to the callback function
  _observer = new MutationObserver(this._callback);
  _paymentFormContainer = document.querySelector(".form-card-info");

  _serviceAddress = document.querySelector(".address-checkout");
  _serviceTimeLabel = document.querySelector(".service-time-label");
  _tipErrorContainer = document.querySelector("#tip-error");
  _tipRate = undefined;

  // Clear the content of the elements
  _clearCartDetails() {
    this._cartSubtotal.textContent = "";
    this._cartDeliveryFee.textContent = "";
    this._cartTotalWithTip.textContent = "";
    this._tipTotal.textContent = "";
    this._deliveryMinimumContainer.style.display = "none";
    this._deliveryMinimumContainer.innerHTML = "";
    this._cartItems.innerHTML = "";
  }

  _clearDeliveryDate() {
    this._deliveryDay.innerHTML = "";
  }

  _clearDeliveryTime() {
    this._deliveryTime.innerHTML = "";
  }

  _clearNoProduct() {
    this._cartItems.textContent = "";
  }

  _generateDate(value, content) {
    return `<option value="${value}">${content}</option>`;
  }

  _generateMarkupPreview(result) {
    const SINGLE_INGREDIENT_COUNT = 1;

    return `
    <div class="box-shaddow-item">
    <div class="item-cart-div">
      <div class="img-checkout-block"><img data-src="${
        result.imageUrl
      }" src=${TEMP_IMG} data-id=${result.idProduct} data-index=${
        result.index
      } alt="" class="image-item"></div>
      <div class="item-details-block-1">
        <div class="item-details-block-2">
        <span class="item-name-checkout">${result.name}</span>
          ${
            result.ingredients.length
              ? `<p class="ingredient-list-js cart">
          ${
            result.ingredients.length > SINGLE_INGREDIENT_COUNT
              ? result.ingredients.map((el) => el.name).join(", ")
              : result.ingredients.map((el) => el.name).join("")
          }
        </p>`
              : ""
          }
          <span class="total-quantity">${i18next.t("product.quantity")}: ${result.quantity}</span>
        </div>
        <div class="item-details-block-2">
          <div class="item-price-block">
            <div class="item-total-price">
              <span>${this.formatCurrency(result.priceTotal)}</span>
            </div>
            <div>
              <button
                type="button"
                class="remove-cart-item"
                aria-label="${i18next.t("cart.removeItem")}"
              >
                <svg
                  class="svg-remove-product"
                  fill="#000000"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 408.483 408.483"
                  stroke="#000000"
                  stroke-width="0.004"
                  aria-hidden="true"
                >
                  <path
                    d="M87.748,388.784c0.461,11.01,9.521,19.699,20.539,19.699h191.911c11.018,0,20.078-8.689,20.539-19.699l13.705-289.316H74.043L87.748,388.784z M247.655,171.329c0-4.61,3.738-8.349,8.35-8.349h13.355c4.609,0,8.35,3.738,8.35,8.349v165.293c0,4.611-3.738,8.349-8.35,8.349h-13.355c-4.61,0-8.35-3.736-8.35-8.349V171.329z M189.216,171.329c0-4.61,3.738-8.349,8.349-8.349h13.355c4.609,0,8.349,3.738,8.349,8.349v165.293c0,4.611-3.737,8.349-8.349,8.349h-13.355c-4.61,0-8.349-3.736-8.349-8.349V171.329L189.216,171.329z M130.775,171.329c0-4.61,3.738-8.349,8.349-8.349h13.356c4.61,0,8.349,3.738,8.349,8.349v165.293c0,4.611-3.738,8.349-8.349,8.349h-13.356c-4.61,0-8.349-3.736-8.349-8.349V171.329z"
                  />
                  <path
                    d="M343.567,21.043h-88.535V4.305c0-2.377-1.927-4.305-4.305-4.305h-92.971c-2.377,0-4.304,1.928-4.304,4.305v16.737H64.916c-7.125,0-12.9,5.776-12.9,12.901V74.47h304.451V33.944C356.467,26.819,350.692,21.043,343.567,21.043z"
                  />
                </svg>
              </button>
            </div>
          </div>
          <button
            type="button"
            class="modify-button word-link"
            data-id="${result.idProduct}"
            data-index="${result.index}"
            title="${i18next.t("cart.updateItem")}"
            aria-label="${i18next.t("cart.updateItem")}"
          >
            ${i18next.t("actions.modify")}
          </button>
        </div>
      </div>
    </div>
  </div>`;
  }

  _generateMarkupResults() {
    return this._data.items
      .map(this._generateMarkupPreview.bind(this))
      .join("");
  }

  // What this location accepts, as rendered into #store-context by the server.
  // The frozen provider registry says what the client can *display*; this says what
  // the restaurant can actually be paid through. Both have to agree before an option
  _generateMobileMoneyPaymentOptions() {
    const { mobileMoneyEnabled, providerCode } = this._locationPaymentConfig();

    if (!mobileMoneyEnabled || !providerCode) {
      return "";
    }

    return getEnabledMobileMoneyProviders()
      .filter(({ id }) => id === providerCode)
      .map(
        (provider) => `
      <div class="payment-option-wrapper">
        <div class="payment-radio-input radio">
          <label for="${provider.inputId}" class="payment-label-container">
            <input
              type="radio"
              id="${provider.inputId}"
              name="paymentMethod"
              class="toggle-input-radio"
              value="${provider.id}"
            >
            <span class="radio-container"></span>
            <span class="payment-option-name">${i18next.t(provider.checkoutLabelKey)}</span>
          </label>
        </div>
      </div>
    `,
      )
      .join("");
  }

  _generateTime(currTime) {
    return `<option value="${currTime}">${currTime}</option>`;
  }

  // Is offered, or the customer picks something the backend will refuse.
  _locationPaymentConfig() {
    const storeContext = document.querySelector("#store-context");
    const readBool = (value, fallback) =>
      typeof value === "string" ? value.toLowerCase() === "true" : fallback;

    return {
      // Default to cash-only: if the context is missing we must not invent a
      // mobile-money option the restaurant has no account for.
      cashEnabled: readBool(storeContext?.dataset.cashEnabled, true),
      mobileMoneyEnabled: readBool(
        storeContext?.dataset.mobileMoneyEnabled,
        false,
      ),
      providerCode: storeContext?.dataset.paymentProvider ?? "",
    };
  }

  addHandlerDeliveryTimeChange(handler) {
    [this._deliveryDay, this._deliveryTime].forEach((el) => {
      if (!el) {
        return;
      }

      el.addEventListener("change", handler);
    });
  }

  addTip() {
    // Minimum possible tip value
    const MIN_TIP = 0;
    const NO_ITEM_COUNT = 0;

    // Activate a tip button and deactivate others
    this._btnTipModest.onclick = () => {
      if (this._data) {
        if (
          Array.isArray(this._data.items) &&
          this._data.items.length !== NO_ITEM_COUNT
        ) {
          if (!this._btnTipModest.classList.contains("toggle-active")) {
            this._btnTipModest.classList.add("toggle-active");
            this.removeActive(this._btnTipStandard);
            this.removeActive(this._btnTipGenerous);
            this.removeActive(this._btnTipCustom);
            this.removeActiveInput();
            // Save tip rate
            this._data.tipRate = 0.1;
            // Save tip rate in cart view
            this._tipRate = this._data.tipRate;
            // Calculate tip
            this._tipTotal.textContent = this.formatCurrency(
              this._data.cartTotalBeforeTip * this._data.tipRate,
            );
            // Save total tip
            this._data.tipTotal =
              this._data.cartTotalBeforeTip * this._data.tipRate;

            // Update total price
            this.updateTextContent(
              this._cartTotalWithTip,
              this._data.cartTotalBeforeTip + this._data.tipTotal,
            );
          }
        }
      }
    };

    this._btnTipStandard.onclick = () => {
      if (this._data) {
        if (
          Array.isArray(this._data.items) &&
          this._data.items.length !== NO_ITEM_COUNT
        ) {
          if (!this._btnTipStandard.classList.contains("toggle-active")) {
            this._btnTipStandard.classList.add("toggle-active");
            this.removeActive(this._btnTipModest);
            this.removeActive(this._btnTipGenerous);
            this.removeActive(this._btnTipCustom);
            this.removeActiveInput();
            // Save tip rate
            this._data.tipRate = 0.15;
            // Save tip rate in cart view
            this._tipRate = this._data.tipRate;
            // Calculate tip
            this._tipTotal.textContent = this.formatCurrency(
              this._data.cartTotalBeforeTip * this._data.tipRate,
            );
            // Save total tip
            this._data.tipTotal =
              this._data.cartTotalBeforeTip * this._data.tipRate;

            // Update total price
            this.updateTextContent(
              this._cartTotalWithTip,
              this._data.cartTotalBeforeTip + this._data.tipTotal,
            );
          }
        }
      }
    };

    this._btnTipGenerous.onclick = () => {
      if (this._data) {
        if (
          Array.isArray(this._data.items) &&
          this._data.items.length !== NO_ITEM_COUNT
        ) {
          if (!this._btnTipGenerous.classList.contains("toggle-active")) {
            this._btnTipGenerous.classList.add("toggle-active");
            this.removeActive(this._btnTipStandard);
            this.removeActive(this._btnTipModest);
            this.removeActive(this._btnTipCustom);
            this.removeActiveInput();
            // Save tip rate
            this._data.tipRate = 0.2;
            // Save tip rate in cart view
            this._tipRate = this._data.tipRate;
            // Calculate tip
            this._tipTotal.textContent = this.formatCurrency(
              this._data.cartTotalBeforeTip * this._data.tipRate,
            );
            // Save total tip
            this._data.tipTotal =
              this._data.cartTotalBeforeTip * this._data.tipRate;

            // Update total price
            this.updateTextContent(
              this._cartTotalWithTip,
              this._data.cartTotalBeforeTip + this._data.tipTotal,
            );
          }
        }
      }
    };

    // Remove old listeners before adding new ones
    const newInputTipCustom = this._inputTipCustom.cloneNode(true);
    this._inputTipCustom.parentNode.replaceChild(
      newInputTipCustom,
      this._inputTipCustom,
    );
    this._inputTipCustom = newInputTipCustom;

    ["input", "click"].forEach((event) => {
      this._inputTipCustom.addEventListener(event, () => {
        if (this._data) {
          if (
            Array.isArray(this._data.items) &&
            this._data.items.length !== NO_ITEM_COUNT
          ) {
            if (!this._inputTipCustom.classList.contains("toggle-active")) {
              this._btnTipCustom.classList.add("toggle-active");
              this.removeActive(this._btnTipStandard);
              this.removeActive(this._btnTipModest);
              this.removeActive(this._btnTipGenerous);
              // Save tip rate
              this._data.tipRate = "custom";
              // Save tip rate in cart view
              this._tipRate = this._data.tipRate;
              if (this._inputTipCustom.value >= MIN_TIP) {
                // Calculate tip
                this._tipTotal.textContent = this.formatCurrency(
                  this._inputTipCustom.value,
                ).replace("-", "");
                // Save total tip
                this._data.tipTotal = Number(this._inputTipCustom.value);

                // Update total price
                this.updateTextContent(
                  this._cartTotalWithTip,
                  this._data.cartTotalBeforeTip + this._data.tipTotal,
                );
              }
            }
          }
        }
      });
    });
  }

  applyAuthUiState() {
    const loggedIn = this.isUserAuthenticatedFromDOM();
    this.setLoggedInFormFieldsLocked(loggedIn);
  }

  // Hide checkout modal after elements click
  closeCart() {
    [this._btnCloseCheckout, this._modalBackgroundCheckout].forEach((el) => {
      el.onclick = (e) => {
        e.preventDefault();

        // Close modal checkout
        this.closeModalCheckout();
      };
    });
  }

  // Hide cart modal Success
  closeCartModalSuccess() {
    // Hide modal
    this._cartSuccess.style.visibility = "hidden";
    this._cartSuccess.style.opacity = "0";
    this._cartSuccess.style.pointerEvents = "none";
  }

  // Render delivery time in cart
  // Disable submit button
  disableButton() {
    this._btnCheckout.disabled = true;
  }

  displayPaymentOption(serviceMode) {
    const mobileMoneyOptions = this._generateMobileMoneyPaymentOptions();
    const { cashEnabled } = this._locationPaymentConfig();

    // Pre-selected only when it is offered: with cash disabled the customer has to
    // pick the mobile-money option deliberately rather than submit a default the
    // restaurant does not accept.
    const cashChecked = cashEnabled ? "checked" : "";

    if (serviceMode === "pickup") {
      const cashOption = cashEnabled
        ? `
        <div class="payment-option-wrapper">
          <div class="payment-radio-input radio">
            <label for="payOnPickup" class="payment-label-container">
              <input
                type="radio"
                id="payOnPickup"
                name="paymentMethod"
                class="toggle-input-radio"
                value="payOnPickup"
                ${cashChecked}
              >
              <span class="radio-container"></span>
              <span class="payment-option-name">${i18next.t("payment.payOnPickup")}</span>
            </label>
          </div>
        </div>
      `
        : "";

      return `
      <div class="box-shaddow-checkout">
        ${cashOption}
        ${mobileMoneyOptions}
      </div>
    `;
    }

    // Delivery (default)
    const cashOption = cashEnabled
      ? `
      <div class="payment-option-wrapper">
        <div class="payment-radio-input radio">
          <label for="payOnDelivery" class="payment-label-container">
            <input
              type="radio"
              id="payOnDelivery"
              name="paymentMethod"
              class="toggle-input-radio"
              value="payOnDelivery"
              ${cashChecked}
            >
            <span class="radio-container"></span>
            <span class="payment-option-name">${i18next.t("payment.payOnDelivery")}</span>
          </label>
        </div>
      </div>
    `
      : "";

    return `
    <div class="box-shaddow-checkout">
      ${cashOption}
      ${mobileMoneyOptions}
    </div>
  `;
  }

  // Open Service modal after edit button click
  editLocation() {
    this._btnEditDeliveryDetails.onclick = () => {
      this.closeModalCheckout();
      this.openModalService();
    };
  }

  // Enable submit button
  enableButton() {
    this._btnCheckout.disabled = false;
  }

  formatDate(date) {
    const TIMEFORMATLENGTH = 2;
    const MONTHOFFSET = 1;
    const year = date.getFullYear();
    // Adding 1 because month is zero-based
    const month = String(date.getMonth() + MONTHOFFSET).padStart(
      TIMEFORMATLENGTH,
      "0",
    );
    const day = String(date.getDate()).padStart(TIMEFORMATLENGTH, "0");
    return `${year}-${month}-${day}`;
  }

  formatTime(totalMinutes) {
    const MINUTES_IN_HOUR = 60;
    const TIMEFORMATLENGTH = 2;

    const hours = Math.floor(totalMinutes / MINUTES_IN_HOUR);
    const minutes = totalMinutes % MINUTES_IN_HOUR;
    return `${String(hours).padStart(TIMEFORMATLENGTH, "0")}:${String(
      minutes,
    ).padStart(TIMEFORMATLENGTH, "0")}`;
  }

  getAvailableTimeSlots(intervals, currentTime) {
    const STARTTIMEINDEX = 0;
    const HOURINDEX = 0;
    const MINUTEINDEX = 1;

    const currentHour = parseInt(currentTime.split(":")[HOURINDEX], 10);
    const currentMinute = parseInt(currentTime.split(":")[MINUTEINDEX], 10);

    const availableSlots = intervals.filter((interval) => {
      const startHour = parseInt(
        interval.split(" - ")[STARTTIMEINDEX].split(":")[HOURINDEX],
        10,
      );
      const startMinute = parseInt(
        interval.split(" - ")[STARTTIMEINDEX].split(":")[MINUTEINDEX],
        10,
      );
      return (
        startHour > currentHour ||
        (startHour === currentHour && startMinute > currentMinute)
      );
    });

    return availableSlots;
  }

  // Extract fulfillment window from selected date and time
  getFulfillmentWindow() {
    const dateValue = document.querySelector("#service-date")?.value;
    const timeValue = document.querySelector("#service-time")?.value;

    // Date is required - if missing, return null for ASAP
    if (!dateValue || !timeValue) {
      return {
        fulfillmentEndTime: null,
        fulfillmentStartTime: null,
      };
    }

    // Parse time slot format "HH:mm - HH:mm"
    const timeMatch = timeValue.match(/^(\d{2}:\d{2})\s*-\s*(\d{2}:\d{2})$/u);
    if (!timeMatch) {
      return {
        fulfillmentEndTime: null,
        fulfillmentStartTime: null,
      };
    }

    const START_TIME_INDEX = 1;
    const END_TIME_INDEX = 2;
    const startTime = timeMatch[START_TIME_INDEX];
    const endTime = timeMatch[END_TIME_INDEX];

    // Build ISO 8601 datetime strings
    const fulfillmentStartTime = `${dateValue}T${startTime}:00+00:00`;
    const fulfillmentEndTime = `${dateValue}T${endTime}:00+00:00`;

    return {
      fulfillmentEndTime,
      fulfillmentStartTime,
    };
  }

  // Find the next opening day
  getNextOpeningDay(currentDate, closingDays) {
    const DAYOFFSET = 1;
    // Move to the next day
    currentDate.setDate(currentDate.getDate() + DAYOFFSET);
    // Check if the given day is a closing day
    if (this.isClosingDay(currentDate, closingDays)) {
      // Find the next opening day
      do {
        // Move to the next day
        currentDate.setDate(currentDate.getDate() + DAYOFFSET);
      } while (
        // Keep moving until a non-closing day is found
        this.isClosingDay(currentDate, closingDays)
      );
    }
    return currentDate;
  }

  getSelectedPaymentMethod() {
    return this._paymentFormContainer.querySelector(
      'input[name="paymentMethod"]:checked',
    )?.value;
  }

  // Put function below in cartview
  handlerAddCart(handler) {
    document.querySelector(".add-to-cart").onclick = handler;
  }

  handlerCheckout(handler) {
    const DELAY_TIMEOUT_MS = 300;

    // Checkout on button click
    this._btnCheckout.onclick = this.debounce(handler, DELAY_TIMEOUT_MS).bind(
      this,
    );
  }

  handlerPaymentMethodChange() {
    let checkoutScrollPosition;

    // Save the modal position before the radio input receives focus
    this._paymentFormContainer.addEventListener("pointerdown", (event) => {
      if (!event.target.closest("label[for]")) {
        return;
      }

      const checkoutContent = this._paymentFormContainer.closest(
        ".content-container-checkout",
      );
      checkoutScrollPosition = checkoutContent?.scrollTop;
    });

    this._paymentFormContainer.addEventListener("change", (event) => {
      if (!event.target.matches('input[name="paymentMethod"]')) {
        return;
      }

      const checkoutContent = this._paymentFormContainer.closest(
        ".content-container-checkout",
      );
      const scrollPosition =
        checkoutScrollPosition ?? checkoutContent?.scrollTop;

      this.updateCheckoutButtonLabel(event.target.value);

      // Restore the position after the CTA label update to prevent a scroll jump
      requestAnimationFrame(() => {
        if (checkoutContent && typeof scrollPosition === "number") {
          checkoutContent.scrollTop = scrollPosition;
        }

        checkoutScrollPosition = undefined;
      });
    });
  }

  handlerRemoveCart(handler) {
    document.querySelectorAll(".remove-cart-item").forEach((element) => {
      element.onclick = handler;
    });
  }

  handlerUpdateCart(handler) {
    document.querySelector(".update-cart").onclick = handler;
  }

  // Call function when tip changes
  handleTipChange() {
    // The tip amount should not exceeed the cart total
    const MAX_TIP = this._data.cartTotalBeforeTip;

    const tipTotal = this.extractNumber(this._tipTotal.textContent);

    if (Number.isNaN(tipTotal)) {
      return;
    }

    if (tipTotal > MAX_TIP) {
      this._tipErrorContainer.textContent = i18next.t("error.tipExceedsMax", {
        amount: this.formatCurrency(MAX_TIP),
      });
      this._tipErrorContainer.style.display = "block";

      // Disable submit button
      this.disableButton();
    } else {
      this._tipErrorContainer.textContent = ``;
      this._tipErrorContainer.style.display = "none";

      // Re-enable submit button when tip is valid
      this.enableButton();
    }
  }

  hideCheckoutButtonLoading() {
    if (!this._btnCheckout) {
      return;
    }

    const buttonText = this._btnCheckout.querySelector(".line-wrapper");

    // Restore original button text
    if (buttonText && this._btnCheckout.dataset.originalText) {
      buttonText.textContent = this._btnCheckout.dataset.originalText;
      delete this._btnCheckout.dataset.originalText;
    }

    // Re-enable button
    this._btnCheckout.disabled = false;
  }

  // Initialize event listeners to control the checkout button state
  initCheckoutBtn(serviceMode) {
    [this._deliveryDay, this._deliveryTime].forEach((el) =>
      el.addEventListener(
        "change",
        this.toggleCheckoutButton.bind(this, serviceMode),
      ),
    );
  }

  /**
   * Auth state is inferred from server-rendered #user-context.
   * - Logged-in: #user-context exists
   * - Guest: missing
   */
  isUserAuthenticatedFromDOM() {
    return Boolean(document.getElementById("user-context"));
  }

  // Open cart modal Success
  openCartModalSuccess() {
    // Show modal
    this._cartSuccess.style.visibility = "visible";
    this._cartSuccess.style.opacity = "1";
    this._cartSuccess.style.pointerEvents = "auto";
  }

  // Remove 'toggle-active' class from tip button
  removeActive(nodes) {
    nodes.classList.remove("toggle-active");
  }

  removeActiveInput() {
    this._inputTipCustom.value = "";
  }

  renderCartError(message = i18next.t("error.cartDisplay")) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();
  }

  renderCartSuccess(message = i18next.t("notification.itemAdded")) {
    this._cartSuccessContainer.textContent = message;
    this.openCartModalSuccess();
  }

  renderCheckoutError(message = i18next.t("error.checkoutFailed")) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();
  }

  renderClearCart(data, serviceMode) {
    this._data = data;
    this.renderFulfillmentHelper(serviceMode);
    const markupResults = this._generateMarkupResults();
    const NO_ITEM_COUNT = 0;
    // Minimum possible tip value
    const MIN_TIP = 0;

    this._clearCartDetails();

    // Parse the specified text as HTML and inserts the resulting nodes into the DOM tree at a specified position.
    this._cartItems.insertAdjacentHTML("afterbegin", markupResults);

    if (
      Array.isArray(this._data.items) &&
      this._data.items.length !== NO_ITEM_COUNT
    ) {
      if (serviceMode !== "pickup") {
        // Show container
        this._cartRowDeliveryFee.style.display = "flex";
        this._cartDeliveryFee.style.display = "block";

        if (this._data.cartSubTotal < this._data.cartSubTotalMinDelivery) {
          // Show container
          this._deliveryMinimumContainer.style.display = "block";
          this._deliveryMinimumContainer.innerHTML = i18next.t(
            "cart.deliveryMinimum",
            {
              amount: this.formatCurrency(this._data.cartSubTotalMinDelivery),
            },
          );
          this.disableButton();
        }
      } else if (serviceMode === "pickup") {
        // Hide container
        this._cartRowDeliveryFee.style.display = "none";
        this._cartDeliveryFee.style.display = "none";
      }

      // Update subtotal
      this.updateTextContent(this._cartSubtotal, this._data.cartSubTotal);

      // Update delivery fees
      if (serviceMode !== "pickup") {
        this.updateTextContent(
          this._cartDeliveryFee,
          this._data.cartDeliveryFees,
        );
      }

      // Update total price
      this.updateTextContent(
        this._cartTotalWithTip,
        this._data.cartTotalBeforeTip,
      );

      // Update total tip
      if (this._tipRate === "custom") {
        this.updateTextContent(
          this._tipTotal,
          Math.max(MIN_TIP, this._inputTipCustom.value),
        );
      } else if (typeof this._tipRate !== "undefined") {
        this.updateTextContent(
          this._tipTotal,
          this._data.cartTotalBeforeTip * this._tipRate,
        );
      } else if (typeof this._tipRate === "undefined") {
        this.updateTextContent(this._tipTotal, MIN_TIP);
      }
    } else if (
      !this._data.items ||
      (Array.isArray(this._data.items) &&
        this._data.items.length === NO_ITEM_COUNT)
    ) {
      this.removeActive(this._btnTipModest);
      this.removeActive(this._btnTipStandard);
      this.removeActive(this._btnTipGenerous);
      this.removeActive(this._btnTipCustom);
      this.removeActiveInput();
      // Remove tipTotal and tipRate properties
      if (typeof this._tipRate !== "undefined") {
        this._tipRate = undefined;
      }
      this.renderNoProduct();
    }

    // Watch target element whenever the target meets the threshold
    document.querySelectorAll(".item-row-cart img[data-src]").forEach((img) => {
      if (img.dataset.src !== "") {
        this._imgObserver.observe(img);
      }
    });
  }

  // Product data is located in this._data
  renderData(data, serviceMode) {
    const NO_ITEM_COUNT = 0;
    this.renderFulfillmentHelper(serviceMode);
    if (
      !data.items ||
      (Array.isArray(data.items) && data.items.length === NO_ITEM_COUNT)
    ) {
      this._clearNoProduct();
      return this.renderNoProduct();
    }
    this._data = data;
    const markupResults = this._generateMarkupResults();

    this._clearCartDetails();

    if (serviceMode !== "pickup") {
      // Show container
      this._cartRowDeliveryFee.style.display = "flex";
      this._cartDeliveryFee.style.display = "block";

      if (this._data.cartSubTotal < this._data.cartSubTotalMinDelivery) {
        // Show container
        this._deliveryMinimumContainer.style.display = "block";
        this._deliveryMinimumContainer.innerHTML = i18next.t(
          "cart.deliveryMinimum",
          {
            amount: this.formatCurrency(this._data.cartSubTotalMinDelivery),
          },
        );
      }

      if (this._data.cartSubTotal >= this._data.cartSubTotalMinDelivery) {
        this.enableButton();
      } else {
        this.disableButton();
      }
    } else if (serviceMode === "pickup") {
      // Hide container
      this._cartRowDeliveryFee.style.display = "none";
      this._cartDeliveryFee.style.display = "none";

      // Enable submit button
      this.enableButton();
    }

    // Parse the specified text as HTML and inserts the resulting nodes into the DOM tree at a specified position.
    this._cartItems.insertAdjacentHTML("afterbegin", markupResults);

    // Update subtotal
    this.updateTextContent(this._cartSubtotal, this._data.cartSubTotal);

    // Update delivery fees
    if (serviceMode !== "pickup") {
      this.updateTextContent(
        this._cartDeliveryFee,
        this._data.cartDeliveryFees,
      );
    }

    // Minimum possible tip value
    const MIN_TIP = 0;

    // Update total tip
    if (this._tipRate === "custom") {
      this.updateTextContent(
        this._tipTotal,
        Math.max(MIN_TIP, this._inputTipCustom.value),
      );

      // Update total price
      this.updateTextContent(
        this._cartTotalWithTip,
        this._data.cartTotalBeforeTip +
          Math.max(MIN_TIP, Number(this._inputTipCustom.value)),
      );
    } else if (typeof this._tipRate !== "undefined") {
      this.updateTextContent(
        this._tipTotal,
        this._data.cartTotalBeforeTip * this._tipRate,
      );

      // Update total price
      this.updateTextContent(
        this._cartTotalWithTip,
        this._data.cartTotalBeforeTip +
          this._data.cartTotalBeforeTip * this._tipRate,
      );
    } else if (typeof this._tipRate === "undefined") {
      this.updateTextContent(this._tipTotal, MIN_TIP);

      // Update total price
      this.updateTextContent(
        this._cartTotalWithTip,
        this._data.cartTotalBeforeTip,
      );
    }

    // Watch target element whenever the target meets the threshold
    document.querySelectorAll(".item-row-cart img[data-src]").forEach((img) => {
      if (img.dataset.src !== "") {
        this._imgObserver.observe(img);
      }
    });

    return true;
  }

  // Render delivery address in cart
  renderDeliveryAddress(name, address, apt, phoneNumber) {
    if (!address) {
      return this.renderError(i18next.t("error.addressInfo"));
    }

    // Change the content of the elements
    // Note: address parameter should already be formatted (street + city if available)
    apt
      ? (this._serviceAddress.innerHTML = `<span class="highlight">${name}</span>, ${address}, #${apt}`)
      : (this._serviceAddress.innerHTML = `<span class="highlight">${name}</span>, ${address}`);

    this._contactInfo.textContent = phoneNumber;

    return true;
  }

  // User's picked Delivery time is located in userTime
  renderDeliveryTime(
    userTime,
    intervalDeliveryMins,
    closingDays,
    deliveryTimes,
    timezone,
  ) {
    const DAYOFFSET = 1;

    if (!intervalDeliveryMins || JSON.stringify(deliveryTimes) === "{}") {
      return this.renderTimeError();
    }
    // Interval of delivery is taken from API
    this._intervalDelivery = intervalDeliveryMins;

    this._clearDeliveryTime();
    this._clearDeliveryDate();

    // 1) Get today's date
    const currentDate = this.getDateInTimezone(timezone);
    let deliveryDateEl;
    let deliveryTimeEl;

    // Add one day to today's date
    const tomorrow = new Date(currentDate);
    tomorrow.setDate(currentDate.getDate() + DAYOFFSET);

    // 2) Get the current time
    const currentTime = this.getTimeFromDate(currentDate);

    // 3) Check if current date is a closing day
    if (this.isClosingDay(currentDate, closingDays)) {
      // If the current date is a closing day

      // Get the next opening day
      const openingDate = this.getNextOpeningDay(currentDate, closingDays);

      // Return the day of the week (An integer, between 0 and 6)
      const dayValue = openingDate.getDay();

      // Retrieve from the API delivery times for the specific day of the week
      const deliveryTimeValue = deliveryTimes[dayValue].map((time) => [
        time.startingHour,
        time.endingHour,
      ]);

      // Get the time slots of the next opening day
      const dayTimeSlots = this.splitTimeIntoIntervals(
        deliveryTimeValue,
        this._intervalDelivery,
      );

      // Get all the time slots of the day
      const availableTimeSlots = dayTimeSlots;

      // Set delivery date
      if (this.formatDate(tomorrow) === this.formatDate(openingDate)) {
        deliveryDateEl = this._generateDate(
          this.formatDate(openingDate),
          i18next.t("dates.tomorrow"),
        );
      } else {
        deliveryDateEl = this._generateDate(
          this.formatDate(openingDate),
          this.formatDate(openingDate),
        );
      }

      this._deliveryDay.insertAdjacentHTML("afterbegin", deliveryDateEl);

      // Set delivery time
      deliveryTimeEl = availableTimeSlots
        .map((el) => this._generateTime(el))
        .join("");

      this._deliveryTime.insertAdjacentHTML("beforeend", deliveryTimeEl);

      // If the most recently selected delivery time is still available and the most recent delivery date is still available, preselect them
      if (
        availableTimeSlots.includes(userTime.deliveryTime) &&
        this.formatDate(openingDate) === userTime.deliveryDay
      ) {
        this._deliveryTime.value = userTime.deliveryTime;
        this._deliveryDay.value = userTime.deliveryDay;
      } else if (this.formatDate(openingDate) === userTime.deliveryDay) {
        // If the most recently selected delivery date is still available, preselect it
        this._deliveryDay.value = userTime.deliveryDay;
      }
    } else {
      // If the current date is not a closing day

      // Return the day of the week (An integer, between 0 and 6)
      let dayValue = currentDate.getDay();

      // Retrieve from the API delivery times for the specific day of the week
      let deliveryTimeValue = deliveryTimes[dayValue].map((time) => [
        time.startingHour,
        time.endingHour,
      ]);

      // Get the time slots of the day
      let dayTimeSlots = this.splitTimeIntoIntervals(
        deliveryTimeValue,
        this._intervalDelivery,
      );

      // Get all the available time slots of the day
      let availableTimeSlots = this.getAvailableTimeSlots(
        dayTimeSlots,
        currentTime,
      );

      // Check if there are available time slots
      if (Array.isArray(availableTimeSlots) && !availableTimeSlots.length) {
        // If there are no available time slots

        // Get the next opening day
        const openingDate = this.getNextOpeningDay(currentDate, closingDays);

        // Return the day of the week (An integer, between 0 and 6)
        dayValue = openingDate.getDay();

        // Retrieve from the API delivery times for the specific day of the week
        deliveryTimeValue = deliveryTimes[dayValue].map((time) => [
          time.startingHour,
          time.endingHour,
        ]);

        // Get the time slots of the next opening day
        dayTimeSlots = this.splitTimeIntoIntervals(
          // Taken from API
          deliveryTimeValue,
          this._intervalDelivery,
        );

        // Get all the time slots of the day
        availableTimeSlots = dayTimeSlots;

        // Set delivery date
        if (this.formatDate(tomorrow) === this.formatDate(openingDate)) {
          deliveryDateEl = this._generateDate(
            this.formatDate(openingDate),
            i18next.t("dates.tomorrow"),
          );
        } else {
          deliveryDateEl = this._generateDate(
            this.formatDate(openingDate),
            this.formatDate(openingDate),
          );
        }
        this._deliveryDay.insertAdjacentHTML("afterbegin", deliveryDateEl);

        // Set delivery time
        deliveryTimeEl = availableTimeSlots
          .map((el) => this._generateTime(el))
          .join("");

        this._deliveryTime.insertAdjacentHTML("beforeend", deliveryTimeEl);

        // If the most recently selected delivery time is still available and the most recent delivery date is still available, preselect them
        if (
          availableTimeSlots.includes(userTime.deliveryTime) &&
          this.formatDate(openingDate) === userTime.deliveryDay
        ) {
          this._deliveryTime.value = userTime.deliveryTime;
          this._deliveryDay.value = userTime.deliveryDay;
        } else if (this.formatDate(openingDate) === userTime.deliveryDay) {
          // If the most recently selected delivery date is still available, preselect it
          this._deliveryDay.value = userTime.deliveryDay;
        }
      } else {
        // If there are available time slots

        // Set delivery date
        deliveryDateEl = this._generateDate(
          this.formatDate(currentDate),
          i18next.t("dates.today"),
        );
        this._deliveryDay.insertAdjacentHTML("afterbegin", deliveryDateEl);

        // Set delivery time
        deliveryTimeEl = availableTimeSlots
          .map((el) => this._generateTime(el))
          .join("");

        // Check whether the restaurant is currently open
        const isRestaurantOpen = this.isTimeWithinAnySlot(
          currentTime,
          deliveryTimeValue,
        );

        this._deliveryTime.insertAdjacentHTML(
          "beforeend",
          isRestaurantOpen
            ? this.setFirstOptionValueEmpty(deliveryTimeEl)
            : deliveryTimeEl,
        );

        // If the most recently selected delivery time is still available and the most recent delivery date is still available, preselect them
        if (
          availableTimeSlots.includes(userTime.deliveryTime) &&
          this.formatDate(currentDate) === userTime.deliveryDay
        ) {
          this._deliveryTime.value = userTime.deliveryTime;
          this._deliveryDay.value = userTime.deliveryDay;
        } else if (this.formatDate(currentDate) === userTime.deliveryDay) {
          // If the most recently selected delivery date is still available, preselect it
          this._deliveryDay.value = userTime.deliveryDay;
        }
      }
    }
    return true;
  }

  renderError(message) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();
  }
  renderFulfillmentHelper(serviceMode) {
    if (!this._fulfillmentHelperText) {
      return;
    }

    const helperKey =
      serviceMode === "pickup"
        ? "checkoutHelper.pickup"
        : "checkoutHelper.delivery";

    this._fulfillmentHelperText.innerHTML = i18next.t(helperKey);

    if (this._fulfillmentHelper) {
      this._fulfillmentHelper.dataset.mode = serviceMode || "delivery";
    }
  }

  renderNoProduct(message = i18next.t("cart.empty")) {
    const markup = `
    <div class="error-cart">
        <p>${message}</p>
    </div>`;

    this._cartItems.insertAdjacentHTML("afterbegin", markup);
    this._inputTipCustom.value = "";

    this.disableButton();
  }

  renderPaymentOption(serviceMode) {
    const paymentFormMarkup = this.displayPaymentOption(serviceMode);
    this._paymentFormContainer.innerHTML = paymentFormMarkup;
    this.updateCheckoutButtonLabel(this.getSelectedPaymentMethod());
  }

  // Callback function to execute when mutations are observed
  renderPickupAddress(name, phoneNumber) {
    const addressEl = document.querySelector(".store-address-js");

    // Handle missing element to prevent crashes
    if (!addressEl) {
      this._serviceAddress.innerHTML = `<span class="highlight">${name}</span>`;
      this._contactInfo.textContent = phoneNumber;
      console.error("Store address element not found in DOM.");
      return;
    }

    const { address } = addressEl.dataset;

    // Render pickup contact block using the restaurant address already stamped into the DOM
    this._serviceAddress.innerHTML = address
      ? `<span class="highlight">${name}</span>, ${address}`
      : `<span class="highlight">${name}</span>`;

    this._contactInfo.textContent = phoneNumber;
  }

  renderTimeError(message = i18next.t("status.restaurantUnavailable")) {
    this._clearDeliveryTime();
    this._clearDeliveryDate();
    this._errorContainer.textContent = message;
    this._deliveryDay.insertAdjacentHTML(
      "afterbegin",
      `<option value>${i18next.t("status.unknown")}</option>`,
    );
    this._deliveryTime.insertAdjacentHTML(
      "beforeend",
      `<option value>${i18next.t("status.unknown")}</option>`,
    );

    // Block checkout when hours are unavailable
    this.disableButton();

    this.openModalError();
  }

  setFirstOptionValueEmpty(deliveryTimeEl) {
    if (!deliveryTimeEl || typeof deliveryTimeEl !== "string") {
      return deliveryTimeEl;
    }

    const select = document.createElement("select");
    select.innerHTML = deliveryTimeEl;

    const firstOption = select.querySelector("option");

    if (firstOption) {
      firstOption.value = "";
    }

    return select.innerHTML;
  }

  //Lock/unlock the core identity fields:
  setLoggedInFormFieldsLocked(locked) {
    const nameEl = document.querySelector(".content-container-service #name");
    const emailEl = document.querySelector(".content-container-service #email");
    const phoneEl = document.querySelector(
      ".content-container-service #phone-number",
    );
    const countryEl = document.querySelector(
      ".content-container-service #country",
    );

    // Inputs: prefer readonly (keeps value submitted)
    [nameEl, emailEl, phoneEl].forEach((el) => {
      if (!el) {
        return;
      }
      el.readOnly = Boolean(locked);
      el.setAttribute("aria-readonly", Boolean(locked));
      el.classList.toggle("is-locked", Boolean(locked));
    });

    // Country select: keep enabled, just block interaction
    if (!countryEl) {
      return;
    }

    countryEl.classList.toggle("is-locked", Boolean(locked));

    if (locked) {
      countryEl.setAttribute("aria-disabled", "true");
    } else {
      countryEl.removeAttribute("aria-disabled");
    }
  }

  showCheckoutButtonLoading() {
    if (!this._btnCheckout) {
      return;
    }

    // Store original button text
    const buttonText = this._btnCheckout.querySelector(".line-wrapper");
    if (buttonText) {
      this._btnCheckout.dataset.originalText = buttonText.textContent;
    }

    // Disable button
    this._btnCheckout.disabled = true;

    // Replace text with circular arc spinner matching the screenshot
    const spinnerMarkup = `
      <svg class="button-spinner" width="24" height="24" viewBox="0 0 50 50" style="display: inline-block; vertical-align: middle;">
        <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="4" stroke-dasharray="90, 150" stroke-linecap="round">
          <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite"/>
        </circle>
      </svg>
    `;

    if (buttonText) {
      buttonText.innerHTML = spinnerMarkup;
    }
  }

  splitTimeIntoIntervals(multipleTimeSlots, intervalMinutes) {
    const HOURS_IN_DAY = 24;
    const MINUTES_IN_HOUR = 60;
    const result = [];

    multipleTimeSlots.forEach((slot) => {
      const [startTime, endTime] = slot;
      const [startHour, startMinute] = startTime.split(":").map(Number);
      const [endHour, endMinute] = endTime.split(":").map(Number);

      const startTotalMinutes = startHour * MINUTES_IN_HOUR + startMinute;
      let endTotalMinutes = endHour * MINUTES_IN_HOUR + endMinute;

      // Adjust end time if it's before start time
      if (endTotalMinutes < startTotalMinutes) {
        // Adding 24 hours
        endTotalMinutes += HOURS_IN_DAY * MINUTES_IN_HOUR;
      }

      for (
        let i = startTotalMinutes;
        i < endTotalMinutes;
        i += intervalMinutes
      ) {
        const intervalEndTime = Math.min(i + intervalMinutes, endTotalMinutes);
        if (intervalEndTime - i < intervalMinutes) {
          break;
        }
        // Modulo 24 hours
        const intervalStartTimeString = this.formatTime(
          i % (HOURS_IN_DAY * MINUTES_IN_HOUR),
        );
        const intervalEndTimeString = this.formatTime(
          // Modulo 24 hours
          intervalEndTime % (HOURS_IN_DAY * MINUTES_IN_HOUR),
        );

        result.push(`${intervalStartTimeString} - ${intervalEndTimeString}`);
      }
    });

    // Sort and remove duplicates from the time slots array
    return [...new Set(result.sort())];
  }

  // Toggle the state of the checkout button based on input/select fields
  toggleCheckoutButton(serviceMode) {
    const NO_ITEM_COUNT = 0;

    if (this._data) {
      if (serviceMode !== "pickup") {
        if (
          this._data.cartSubTotal < this._data.cartSubTotalMinDelivery ||
          !this._data.items ||
          (Array.isArray(this._data.items) &&
            this._data.items.length === NO_ITEM_COUNT)
        ) {
          // Disable submit button
          this.disableButton();
        } else {
          // Enable submit button
          this.enableButton();
        }
      } else if (
        !this._data.items ||
        (Array.isArray(this._data.items) &&
          this._data.items.length === NO_ITEM_COUNT)
      ) {
        // Disable submit button
        this.disableButton();
      } else {
        // Enable submit button
        this.enableButton();
      }
    }
  }

  updateCheckoutButtonLabel(paymentMethod) {
    const buttonText = this._btnCheckout.querySelector(".line-wrapper");

    if (!buttonText) {
      return;
    }

    if (!this._btnCheckout.dataset.defaultText) {
      this._btnCheckout.dataset.defaultText = buttonText.textContent.trim();
    }

    buttonText.textContent = getMobileMoneyProvider(paymentMethod)
      ? i18next.t("actions.continueToPayment")
      : this._btnCheckout.dataset.defaultText;
  }

  updateDeliveryLabel() {
    this._serviceTimeLabel.innerHTML = `${i18next.t("service.deliveryTime")}:<span class="required-field"> * </span>`;
    this._labelAddress.innerHTML = `${i18next.t("service.deliveryDetails")}:`;

    // Show container
    this._cartRowDeliveryFee.style.display = "flex";
    this._cartDeliveryFee.style.display = "block";
  }

  updatePickupLabel() {
    this._serviceTimeLabel.innerHTML = `${i18next.t("service.pickupTime")}:<span class="required-field"> * </span>`;
    this._labelAddress.innerHTML = `${i18next.t("service.pickupDetails")}:`;

    // Hide container
    this._cartRowDeliveryFee.style.display = "none";
    this._cartDeliveryFee.style.display = "none";
  }

  updateTextContent(elements, value) {
    elements.textContent = this.formatCurrency(Number(value));
  }

  // Watch element whenever the text content changes
  watchTip() {
    this._observer.observe(this._tipTotal, this._config);
  }
}

export default new CartView();
